import type { FileMetadata } from '@magicschool/business-logic/tools';
import { generateId } from 'ai';
import type { ChatMessage } from 'features/model-interaction/types';
import { getMaxRandomInt } from 'util/math';

export function makeToolInputMessage(inputs: any, userId?: string, threadId?: number, toolSlug?: string): ChatMessage {
  toolSlug = toolSlug ?? 'undefined'; // TODO: maybe make constructor receive parameters when streaming
  return {
    role: 'user',
    user_id: userId,
    assistant_thread_id: threadId,
    content: [
      {
        type: 'tool_inputs',
        toolId: toolSlug,
        inputs,
      },
    ],
  };
}

export function makeToolOutputMessage({
  output,
  model,
  tool_config_id,
  userId,
  threadId,
  toolSlug,
  generationId,
}: {
  output: string;
  model: string;
  tool_config_id: string;
  userId?: string;
  threadId?: number;
  toolSlug?: string;
  generationId?: string;
}): ChatMessage {
  toolSlug = toolSlug || 'undefined';
  return {
    role: 'assistant',
    user_id: userId,
    assistant_thread_id: threadId,
    content: [
      {
        type: 'tool_output',
        toolId: toolSlug,
        output,
        model,
        tool_config_id,
        generation_id: generationId,
      },
    ],
    message_payload: {
      metadata: { model, generation_id: generationId, tool_config_id, message_payload_version: 1 },
      uiMessage: { id: generateId(), role: 'assistant', parts: [{ type: 'text', text: output }] },
    },
  };
}

export function makeBasicRequestMessage(input: string, userId?: string, threadId?: number, files?: FileMetadata[]): ChatMessage {
  return {
    role: 'user',
    id: getMaxRandomInt(),
    user_id: userId,
    assistant_thread_id: threadId,
    content: [
      {
        type: 'text',
        text: input,
        files,
      },
    ],
  };
}

export function makeBasicResponseMessage({
  output,
  tool_config_id,
  model,
  userId,
  threadId,
  generationId,
}: {
  output: string;
  tool_config_id: string;
  model: string;
  userId?: string;
  threadId?: number;
  generationId?: string;
}): ChatMessage {
  return {
    role: 'assistant',
    user_id: userId,
    assistant_thread_id: threadId,
    content: [
      {
        type: 'text',
        text: output,
        model,
        tool_config_id,
        generation_id: generationId,
      },
    ],
    message_payload: {
      metadata: { model, generation_id: generationId, tool_config_id, message_payload_version: 1 },
      uiMessage: { id: generateId(), role: 'assistant', parts: [{ type: 'text', text: output }] },
    },
  };
}

export const IMAGE_LOADING_MESSAGE = {
  isProcessingImage: true,
  ...makeBasicResponseMessage({
    output: '',
    model: '',
    threadId: -1,
    tool_config_id: '',
  }),
};
